import React from 'react';
import {useTranslation} from "react-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">{t('privacyPolicyPage.privacyPolicy')}</h1>
        <p className="text-gray-600">{t('privacyPolicyPage.lastUpdated')}</p>
      </div>

      {/* Introduction */}
      <section className="mb-10">
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.introduction')}
        </p>
      </section>

      {/* Interpretation and Definitions */}
      <section className="mb-10">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">{t('privacyPolicyPage.interpretationDefinitions')}</h2>

        <h3 className="text-xl font-medium text-gray-900 mb-2">{t('privacyPolicyPage.interpretation')}</h3>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.interpretationText')}
        </p>

        <h3 className="text-xl font-medium text-gray-900 mb-2">{t('privacyPolicyPage.definitions')}</h3>
        <p className="text-gray-700 mb-4">{t('privacyPolicyPage.definitionsText')}</p>

        <ul className="space-y-4">
          <li>
            <p className="text-gray-700"><strong>{t('privacyPolicyPage.account')}</strong> {t('privacyPolicyPage.accountText')}</p>
          </li>
          <li>
            <p className="text-gray-700"><strong>{t('privacyPolicyPage.affiliate')}</strong> {t('privacyPolicyPage.affiliateText')}</p>
          </li>
          <li>
            <p className="text-gray-700"><strong>{t('privacyPolicyPage.application')}</strong> {t('privacyPolicyPage.applicationText')}</p>
          </li>
          <li>
            <p className="text-gray-700"><strong>{t('privacyPolicyPage.company')}</strong> {t('privacyPolicyPage.companyText')}</p>
          </li>
          <li>
            <p className="text-gray-700"><strong>{t('privacyPolicyPage.country')}</strong> {t('privacyPolicyPage.countryText')}</p>
          </li>
          <li>
            <p className="text-gray-700"><strong>{t('privacyPolicyPage.device')}</strong> {t('privacyPolicyPage.deviceText')}</p>
          </li>
          <li>
            <p className="text-gray-700"><strong>{t('privacyPolicyPage.personalData')}</strong> {t('privacyPolicyPage.personalDataText')}</p>
          </li>
          <li>
            <p className="text-gray-700"><strong>{t('privacyPolicyPage.service')}</strong> {t('privacyPolicyPage.serviceText')}</p>
          </li>
          <li>
            <p className="text-gray-700"><strong>{t('privacyPolicyPage.serviceProvider')}</strong> {t('privacyPolicyPage.serviceProviderText')}</p>
          </li>
          <li>
            <p className="text-gray-700"><strong>{t('privacyPolicyPage.thirdParty')}</strong> {t('privacyPolicyPage.thirdPartyText')}</p>
          </li>
          <li>
            <p className="text-gray-700"><strong>{t('privacyPolicyPage.usageData')}</strong> {t('privacyPolicyPage.usageDataText')}</p>
          </li>
          <li>
            <p className="text-gray-700"><strong>{t('privacyPolicyPage.you')}</strong> {t('privacyPolicyPage.youText')}</p>
          </li>
        </ul>
      </section>

      {/* Collecting and Using Your Personal Data */}
      <section className="mb-10">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">{t('privacyPolicyPage.collectingData')}</h2>

        <h3 className="text-xl font-medium text-gray-900 mb-2">{t('privacyPolicyPage.typesDataCollected')}</h3>
        <h4 className="text-lg font-medium text-gray-900 mb-2">{t('privacyPolicyPage.personalDataCollected')}</h4>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.personalDataCollectedText')}
        </p>

        <ul className="list-disc pl-5 space-y-2 mb-4">
          <li className="text-gray-700">{t('privacyPolicyPage.firstName')}</li>
          <li className="text-gray-700">{t('privacyPolicyPage.email')}</li>
          <li className="text-gray-700">{t('privacyPolicyPage.phone')}</li>
          <li className="text-gray-700">{t('privacyPolicyPage.address')}</li>
          <li className="text-gray-700">{t('privacyPolicyPage.usageData')}</li>
        </ul>

        <h4 className="text-lg font-medium text-gray-900 mb-2">{t('privacyPolicyPage.usageDataCollected')}</h4>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.usageDataCollectedText')}
        </p>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.usageDataDetails1')}
        </p>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.usageDataDetails2')}
        </p>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.usageDataDetails3')}
        </p>

        <h4 className="text-lg font-medium text-gray-900 mb-2">{t('privacyPolicyPage.infoCollectedApp')}</h4>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.infoCollectedAppText')}
        </p>

        <ul className="list-disc pl-5 space-y-2 mb-4">
          <li className="text-gray-700">{t('privacyPolicyPage.location')}</li>
          <li className="text-gray-700">{t('privacyPolicyPage.pictures')}</li>
        </ul>

        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.infoUsage')}
        </p>
        <p className="text-gray-700">
          {t('privacyPolicyPage.infoSettings')}
        </p>
      </section>

      {/* Use of Your Personal Data */}
      <section className="mb-10">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">{t('privacyPolicyPage.usePersonalData')}</h2>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.usePersonalDataText')}
        </p>

        <ul className="list-disc pl-5 space-y-2 mb-4">
          <li className="text-gray-700">{t('privacyPolicyPage.provideService')}</li>
          <li className="text-gray-700">{t('privacyPolicyPage.manageAccount')}</li>
          <li className="text-gray-700">{t('privacyPolicyPage.performanceContract')}</li>
          <li className="text-gray-700">{t('privacyPolicyPage.contactYou')}</li>
          <li className="text-gray-700">{t('privacyPolicyPage.provideNews')}</li>
          <li className="text-gray-700">{t('privacyPolicyPage.manageRequests')}</li>
        </ul>

        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.shareInfo')}
        </p>

        <ul className="list-disc pl-5 space-y-2">
          <li className="text-gray-700"><strong>{t('privacyPolicyPage.withServiceProviders')}</strong> {t('privacyPolicyPage.withServiceProvidersText')}</li>
          <li className="text-gray-700"><strong>{t('privacyPolicyPage.businessTransfers')}</strong> {t('privacyPolicyPage.businessTransfersText')}</li>
          <li className="text-gray-700"><strong>{t('privacyPolicyPage.withAffiliates')}</strong> {t('privacyPolicyPage.withAffiliatesText')}</li>
          <li className="text-gray-700"><strong>{t('privacyPolicyPage.businessPartners')}</strong> {t('privacyPolicyPage.businessPartnersText')}</li>
          <li className="text-gray-700"><strong>{t('privacyPolicyPage.otherUsers')}</strong> {t('privacyPolicyPage.otherUsersText')}</li>
        </ul>
      </section>

      {/* Retention of Your Personal Data */}
      <section className="mb-10">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">{t('privacyPolicyPage.retentionData')}</h2>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.retentionDataText')}
        </p>
        <p className="text-gray-700">
          {t('privacyPolicyPage.retentionUsageData')}
        </p>
      </section>

      {/* Transfer of Your Personal Data */}
      <section className="mb-10">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">{t('privacyPolicyPage.transferData')}</h2>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.transferDataText1')}
        </p>
        <p className="text-gray-700">
          {t('privacyPolicyPage.transferDataText2')}
        </p>
      </section>

      {/* Disclosure of Your Personal Data */}
      <section className="mb-10">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">{t('privacyPolicyPage.disclosureData')}</h2>

        <h3 className="text-xl font-medium text-gray-900 mb-2">{t('privacyPolicyPage.businessTransactions')}</h3>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.businessTransactionsText')}
        </p>

        <h3 className="text-xl font-medium text-gray-900 mb-2">{t('privacyPolicyPage.lawEnforcement')}</h3>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.lawEnforcementText')}
        </p>

        <h3 className="text-xl font-medium text-gray-900 mb-2">{t('privacyPolicyPage.otherLegal')}</h3>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.otherLegalText')}
        </p>

        <ul className="list-disc pl-5 space-y-2">
          <li className="text-gray-700">{t('privacyPolicyPage.complyLegal')}</li>
          <li className="text-gray-700">{t('privacyPolicyPage.protectRights')}</li>
          <li className="text-gray-700">{t('privacyPolicyPage.preventWrongdoing')}</li>
          <li className="text-gray-700">{t('privacyPolicyPage.protectSafety')}</li>
          <li className="text-gray-700">{t('privacyPolicyPage.legalLiability')}</li>
        </ul>
      </section>

      {/* Security of Your Personal Data */}
      <section className="mb-10">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">{t('privacyPolicyPage.securityData')}</h2>
        <p className="text-gray-700">
          {t('privacyPolicyPage.securityDataText')}
        </p>
      </section>

      {/* Detailed Information on the Processing of Your Personal Data */}
      <section className="mb-10">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">{t('privacyPolicyPage.processingDetails')}</h2>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.processingDetailsText')}
        </p>

        <h3 className="text-xl font-medium text-gray-900 mb-2">{t('privacyPolicyPage.analytics')}</h3>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.analyticsText')}
        </p>

        <h4 className="text-lg font-medium text-gray-900 mb-2">{t('privacyPolicyPage.googleAnalytics')}</h4>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.googleAnalyticsText1')}
        </p>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.googleAnalyticsText2')}
        </p>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.googleAnalyticsText3')}
        </p>

        <h4 className="text-lg font-medium text-gray-900 mb-2">{t('privacyPolicyPage.firebase')}</h4>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.firebaseText1')}
        </p>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.firebaseText2')}
        </p>
        <p className="text-gray-700">
          {t('privacyPolicyPage.firebaseText3')}
        </p>
      </section>

      {/* Email Marketing */}
      <section className="mb-10">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">{t('privacyPolicyPage.emailMarketing')}</h2>
        <p className="text-gray-700">
          {t('privacyPolicyPage.emailMarketingText')}
        </p>
      </section>

      {/* Your California Privacy Rights */}
      <section className="mb-10">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">{t('privacyPolicyPage.californiaRights')}</h2>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.californiaRightsText1')}
        </p>
        <p className="text-gray-700">
          {t('privacyPolicyPage.californiaRightsText2')}
        </p>
      </section>

      {/* California Privacy Rights for Minor Users */}
      <section className="mb-10">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">{t('privacyPolicyPage.californiaMinors')}</h2>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.californiaMinorsText1')}
        </p>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.californiaMinorsText2')}
        </p>
        <p className="text-gray-700">
          {t('privacyPolicyPage.californiaMinorsText3')}
        </p>
      </section>

      {/* Links to Other Websites */}
      <section className="mb-10">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">{t('privacyPolicyPage.linksWebsites')}</h2>
        <p className="text-gray-700">
          {t('privacyPolicyPage.linksWebsitesText')}
        </p>
      </section>

      {/* Changes to this Privacy Policy */}
      <section className="mb-10">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">{t('privacyPolicyPage.changesPolicy')}</h2>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.changesPolicyText1')}
        </p>
        <p className="text-gray-700 mb-4">
          {t('privacyPolicyPage.changesPolicyText2')}
        </p>
        <p className="text-gray-700">
          {t('privacyPolicyPage.changesPolicyText3')}
        </p>
      </section>

      {/* Contact Us */}
      {/*<section>*/}
      {/*  <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">{t('privacyPolicyPage.contactUs')}</h2>*/}
      {/*  <p className="text-gray-700">*/}
      {/*    {t('privacyPolicyPage.contactUsText')}*/}
      {/*  </p>*/}
      {/*</section>*/}
    </div>
  );
};

export default PrivacyPolicy;